import { postRequest } from "../../config/AxiosConfig";
import API_URLS from "../../config/BackendConfig";
import { getAuthToken } from "../../utils/tokenUtils";

export const getDinBulkReport = async (payload) => {
  try {
    const token = getAuthToken();

    const res = await postRequest({
      url: API_URLS.ADMIN + `bulk-service/din`,

      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: payload,
    });

    return res;
  } catch (error) {
    console.log(error);
  }
};

export const getGstBulkReport = async (payload) => {
  try {
    const token = getAuthToken();

    const res = await postRequest({
      url: API_URLS.ADMIN + `bulk-service/gstin`,

      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: payload,
    });

    return res;
  } catch (error) {
    console.log(error);
  }
};

export const getRcBulkReport = async (payload) => {
  try {
    const token = getAuthToken();

    const res = await postRequest({
      url: API_URLS.ADMIN + `bulk-service/rc`,

      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: payload,
    });

    return res;
  } catch (error) {
    console.log(error);
  }
};
export const dispatchJobBulk = async ({ service, id }) => {
  try {
    const token = getAuthToken();

    const res = await postRequest({
      url: API_URLS.ADMIN + `bulk-service/dispatch/${service}/${id}`,

      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    return res;
  } catch (error) {
    console.log(error);
  }
};
export const updateStatusBulk = async (id) => {
  try {
    const token = getAuthToken();

    const res = await postRequest({
      url: API_URLS.ADMIN + `bulk-service/update-status/din/${id}`,

      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        status: "processing",
      },
    });

    return res;
  } catch (error) {
    console.log(error);
  }
};
export const forceCompleteBulk = async ({ service, id }) => {
  try {
    const token = getAuthToken();

    const res = await postRequest({
      url: API_URLS.ADMIN + `bulk-service/force-complete/${service}/${id}`,

      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    return res;
  } catch (error) {
    console.log(error);
  }
};

export const downloadBulkPan = async ({
  api_id,
  api_key,
  token_id,
  reference_id,
}) => {
  const payload = { api_id, api_key, token_id, reference_id };
  try {
    const token = getAuthToken();

    const res = await postRequest({
      url: API_URLS.ADMIN + `srv2/bulk-pan-to-contact/download`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: payload,
    });

    return res;
  } catch (error) {
    console.log(error);
  }
};

export const getBukReportPan = async (paylaod) => {
  try {
    const token = getAuthToken();

    const response = await postRequest({
      url: API_URLS.ADMIN + `bulk-service/panToContact`,
      data: paylaod,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    return response;
  } catch (error) {
    console.error(
      "Bulk DIN Upload Error:",
      error.response?.data || error.message,
    );
    throw error;
  }
};
